export default "__VITE_ASSET__5HvaEFcJ__"